/**
 * Analytics utility for safely handling document.write operations
 * This utility intercepts and safely handles document.write calls to prevent
 * issues in modern web applications, especially with Next.js
 */

/**
 * Initializes safe document.write interceptor
 * This function overrides the native document.write and document.writeln methods
 * to handle content safely without breaking the page rendering
 */
export function initializeDocumentWriteInterceptor() {
    // Only run in browser environment
    if (typeof document === 'undefined') {
        return;
    }

    // Store original document.write methods
    var originalDocWrite = document.write;
    var originalDocWriteln = document.writeln;

    // Create a safe replacement that appends to body instead
    function safeDocumentWrite(content) {

        // Parse and safely insert the content
        if (typeof content === 'string') {
            // Handle script tags specially
            if (content.includes('<script') && content.includes('src=')) {
                var srcMatch = content.match(/src=["']([^"']+)["']/);
                if (srcMatch && srcMatch[1]) {
                    var script = document.createElement('script');
                    script.src = srcMatch[1];
                    script.async = true;
                    document.head.appendChild(script);
                    return;
                }
            }

            // Handle style tags
            if (content.includes('<style')) {
                var styleMatch = content.match(/<style[^>]*>(.*?)<\/style>/s);
                if (styleMatch && styleMatch[1]) {
                    var style = document.createElement('style');
                    style.textContent = styleMatch[1];
                    document.head.appendChild(style);
                    return;
                }
            }

            // Handle div tags and other HTML
            if (content.includes('<div') || content.includes('<span')) {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = content;

                // Append children to body
                while (tempDiv.firstChild) {
                    document.body.appendChild(tempDiv.firstChild);
                }
                return;
            }
        }
    }

    // Override document.write methods
    document.write = safeDocumentWrite;
    document.writeln = function(content) {
        safeDocumentWrite(content + '\n');
    };
}

export default {
    initializeDocumentWriteInterceptor
};
